export default __webpack_public_path__ + "static/media/yeopen_mobile_small.a46e1d1c.jpg";